var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "125mm",
    viewBox: "0 0 100 125",
    id: "svg48028",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs48025"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 52.973961,
    width: 52.973961,
    id: "rect34358",
    x: 34.254055,
    y: 78.823776,
    style: {
      stroke: "none",
      strokeWidth: 2.20725,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.625,68.749993 H 24.999999 V 50.000007 H 40.625 V 34.375009 h 18.75 V 50.000007 H 75.000001 V 68.749993 H 59.375 V 84.374991 H 40.625 Z M 50.000001,0 0,18.750014 V 56.812505 C 0,88.374994 21.312501,117.8125 50.000001,125.00001 78.687499,117.8125 100,88.374994 100,56.812505 V 18.750014 Z",
    id: "path34360",
    style: {
      fill: "#5b2d7d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.25001,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.c91b659665d1c9be6d75bf843be845be.svg";
export { ForwardRef as ReactComponent };